import { XTwitterIcon } from '@synoptic/ui-kit/icons/react/x-twitter.tsx';
import { FC, useState } from 'react';
import { useNavigate } from 'react-router';
import { ReplaceUsernameModal } from '@/components/xcom-tag/replace-username-warning-modal.tsx';
import { paths } from '@/routes-utils/paths.ts';
import { useMe } from '@/routes/_app/use-me.ts';
import { SetXComHandleModal } from './set-xcom-handle-modal.tsx';
import { useConnectToX } from './use-connect-to-x.ts';
import { websiteLink } from './xcom-tag.css.ts';

export const XComTag: FC<{
  xComHandle?: string | null;
  isMe: boolean;
  noLogo?: boolean;
}> = ({ xComHandle, isMe, noLogo }) => {
  if (!isMe) {
    return <PublicXComTag xComHandle={xComHandle} noLogo={noLogo} />;
  }

  return <MyXComTag xComHandle={xComHandle} noLogo={noLogo} />;
};

const PublicXComTag: FC<{
  xComHandle?: string | null;
  noLogo?: boolean;
}> = ({ xComHandle, noLogo }) => {
  const icon = noLogo ? null : <XTwitterIcon width={15} height={15} />;

  if (!xComHandle) {
    return (
      <div className={websiteLink}>
        {icon}
        Not connected
      </div>
    );
  }

  return (
    <a
      target={'_blank'}
      className={websiteLink}
      href={`https://x.com/${xComHandle}`}
      rel="noreferrer"
    >
      {icon}@{xComHandle}
    </a>
  );
};

const MyXComTag: FC<{
  xComHandle?: string | null;
  noLogo?: boolean;
}> = ({ xComHandle, noLogo }) => {
  const me = useMe();
  const { isAfterConnect, authLink } = useConnectToX();
  const [open, onOpenChange] = useState(
    !!(xComHandle && isAfterConnect && me.username !== xComHandle),
  );
  const navigate = useNavigate();

  const link = xComHandle ? `https://x.com/${xComHandle}` : authLink;

  const icon = noLogo ? null : <XTwitterIcon width={15} height={15} />;

  const isXComHandleUsername = !me.protectedFields?.possibleUsernames?.includes(
    me.username,
  );

  return xComHandle ? (
    <>
      <a target={'_blank'} className={websiteLink} href={link} rel="noreferrer">
        {icon}@{xComHandle}
      </a>
      <SetXComHandleModal
        username={xComHandle}
        onOpenChange={onOpenChange}
        onSetUsername={(username) => navigate(paths.makeUser(username))}
        open={open}
      />
    </>
  ) : isXComHandleUsername ? (
    <ReplaceUsernameModal
      link={link}
      trigger={
        <span className={websiteLink} style={{ cursor: 'pointer' }}>
          {icon}
          Connect now
        </span>
      }
    />
  ) : (
    <a target={'_self'} className={websiteLink} href={link}>
      {icon}
      Connect now
    </a>
  );
};
